import { UserType } from "../common/types/user";
import { useUser } from "./useUser";

export function useIsDemoUser(): boolean {
    const user = useUser();

    return user.type === UserType.DEMO;
}
